import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as React from 'react';
import { LocalizeContextProps, withLocalize } from 'react-localize-redux';
import { connect } from 'react-redux';
import { DropdownItem } from 'reactstrap';
import { Dispatch } from 'redux';
import { hasPrivilege } from '../../../stores/auth/selectors';
import { deleteGroups } from '../../../stores/groups/actionCreators';
import { getGroupName } from '../../../stores/groups/selectors';
import { RootState } from '../../../stores/store';
import { selected } from '../../../stores/tables/selectors';
import ConfirmModal from '../../common/modals/ConfirmModal';

interface Props extends LocalizeContextProps {
    getName: (id: string) => string;
    hasPrivilege: (privileges: string[]) => boolean;
    selected: string[];

    deleteGroups: (ids: string[]) => void;
}
interface State {
    showModal: boolean;
}

class DeleteGroupsAction extends React.Component<Props, State> {
    public constructor(props: Props) {
        super(props);
        this.state = {
            showModal: false,
        };
    }

    public render() {
        const t = this.props.translate;
        if (this.props.hasPrivilege(['DELETE_GROUP', 'USER_ADMIN', 'SUPER_ADMIN'])) {
            return (
                <React.Fragment>
                    <DropdownItem
                        className="danger"
                        onClick={() => {
                            this.setState({ showModal: true });
                        }}
                    >
                        <FontAwesomeIcon icon={['fal', 'trash']} />
                        {t('groups.button.delete')}
                    </DropdownItem>
                    <ConfirmModal
                        header={t('groups.modal.delete.header') as string}
                        confirmText={t('groups.modal.delete.delete') as string}
                        buttonColor="danger"
                        isOpen={this.state.showModal}
                        confirm={() => {
                            this.props.deleteGroups(this.props.selected);
                        }}
                        cancel={() => { this.setState({ showModal: false }); }}
                    >
                        {t('groups.modal.delete.text') as string} <b>{this.getHandle()}</b>?
                    </ConfirmModal>
                </React.Fragment>
            );
        } else {
            return null;
        }
    }

    private getHandle = () => {
        const t = this.props.translate;
        if (this.props.selected.length !== 1) {
            return t(
                'groups.modal.delete.groups',
                { number: this.props.selected.length }
            );
        } else {
            return this.props.getName(this.props.selected[0]);
        }
    }
}

const mapStateToProps = (state: RootState) => ({
    getName: getGroupName(state),
    hasPrivilege: hasPrivilege(state),
    selected: selected(state, 'groups'),
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
    deleteGroups: (ids: string[]) => dispatch(deleteGroups(ids)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withLocalize(DeleteGroupsAction));